import React from 'react';
import './globals.css';
import './styles.css';

export default function App(): React.JSX.Element {
  return (
    <div className="page">
      <img src="/nb_logo_eyes_200_200.png" alt="Neurodex Logo" className="logo" />
      <div className="text">
        <h1>Neurodex is on maintenance!</h1>
        <p>
          We&apos;re performing a quick systems upgrade to bring you sharper calls & faster trades.
          Hold tight - the Neurodex terminal will be back online soon, stronger than ever.
        </p>
        <p style={{ marginTop: '2em', fontStyle: 'italic' }}>Yours truly – Neurobro team</p>
      </div>
    </div>
  );
}
